var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDnaColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5H8V3H14V5Z",
    fill: "#208C72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9H10V7H16V9Z",
    fill: "#F28520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 19H8V21H14V19Z",
    fill: "#208C72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15H10V17H16V15Z",
    fill: "#F28520"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.6V2H6V9L6.27586 9.68966L9.133 12.6897L9.85714 13H14.3425L16 15V22H18V14.6795L17.8137 14.0983L15.6709 11.4188L14.8571 11H10.2857L8 8.6Z",
    fill: "#3360AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.67954V2H18V9L17.8137 9.58124L15.6709 12.5812L14.8571 13H10.2857L8 15V22H6V14.6L6.27586 13.9103L9.133 11.3103L9.85714 11H14.3425L16 8.67954Z",
    fill: "#3360AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaColor);
export default __webpack_public_path__ + "static/media/dna-color.514b791cc74661ae3c2451cd45e9ab0f.svg";
export { ForwardRef as ReactComponent };